import { memo } from 'react';
import PropTypes from 'prop-types';
import * as styles from './styles/styles.module.scss';
import { MapStatsUtil } from '../../utils/map_stats_util';
import { StringConstantsMixin } from '../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import { translateRouteType } from '../../utils/trail_helpers';
import LanguageRegionCode from '@alltrails/shared/types/LanguageRegionCode';

const TrailStats = ({ trail, routeType, displayMetric, languageRegionCode }) => {
  return (
    <section className={styles.trailStatSection}>
      <div>
        <span className={styles.trailStatIcons}>
          <span className={styles.statsLabel}>{StringConstantsMixin.strings.FILTERS.LENGTH}</span>
          <span className={styles.detailData}>{MapStatsUtil.metersToFormattedUserUnits(trail.length, 1, displayMetric, languageRegionCode)}</span>
        </span>
        <span className={styles.trailStatIcons}>
          <span className={styles.statsLabel}>{StringConstantsMixin.strings.FILTERS.ELEV_GAIN}</span>
          <span className={styles.detailData}>{MapStatsUtil.elevationFormatted(trail.elevation_gain, displayMetric, languageRegionCode)}</span>
        </span>
        <span className={styles.trailStatIcons}>
          <span className={styles.statsLabel}>{StringConstantsMixin.strings.FILTERS.ROUTE_TYPE}</span>
          <span className={styles.detailData}>{translateRouteType(routeType)}</span>
        </span>
      </div>
    </section>
  );
};

TrailStats.propTypes = {
  trail: PropTypes.object.isRequired,
  routeType: PropTypes.string,
  displayMetric: PropTypes.bool,
  languageRegionCode: PropTypes.string
};

TrailStats.defaultProps = {
  displayMetric: false,
  routeType: '',
  languageRegionCode: LanguageRegionCode.English
};

export default memo(TrailStats);
